"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPrice = void 0;
const formatPrice = price => {
  const clean = String(price).replace(/[^\d.-]/g, '');
  const num = Number(clean);
  if (isNaN(num)) {
    return '0.00';
  }
  return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '\'');
};
exports.formatPrice = formatPrice;
//# sourceMappingURL=formatPrice.js.map